/**
 * Estatus de una tarea tal como lo muestra Torre de Control.
 *
 * El backend manda `state_now` con la etiqueta del modelo (`Completada`,
 * `Completada a tiempo`, `Completada fuera de tiempo`), pero en el diseño solo
 * existe UN estatus de cierre: "Finalizada". Esta es la única traducción, para
 * que tarjeta, tabla y Excel digan lo mismo.
 */

export const FINISHED_LABEL = 'Finalizada'

export const STATE_COLORS = {
  finished: '#0FAB1E',
  in_progress: '#1A8EE2',
  overdue: '#BF3B43',
  suspended: '#B7791F'
}

/**
 * Color del TEXTO del estatus en la tabla (Figma "Tabla ESTATUS" 348:7086):
 * En Proceso #1A8EE2, Vencida #F22E2E, Finalizada #0FAB1E. El diseño no tiene
 * una celda de "Suspendida"; conserva el ámbar del módulo.
 */
export const LIST_STATE_COLORS = {
  finished: '#0FAB1E',
  in_progress: '#1A8EE2',
  overdue: '#F22E2E',
  suspended: '#B7791F'
}

const FINISHED_RAW = ['Completada', 'Completada a tiempo', 'Completada fuera de tiempo', 'Finalizada']

/**
 * Etiqueta visible del estatus. Cualquier variante de "Completada" es
 * "Finalizada".
 */
export function stateLabel (task) {
  const raw = task && task.state_now ? String(task.state_now) : ''
  if (!raw) return ''

  return FINISHED_RAW.includes(raw) ? FINISHED_LABEL : raw
}

/**
 * Clave de columna del tablero a la que pertenece la tarea.
 */
export function stateKey (task) {
  if (task && task.board_state) return task.board_state

  switch (stateLabel(task)) {
    case FINISHED_LABEL: return 'finished'
    case 'Vencida': return 'overdue'
    case 'En Proceso': return 'in_progress'
    case 'Suspendida': return 'suspended'
    default: return null
  }
}

/**
 * Color del texto del estatus. Finalizada es #0FAB1E (lo pidió René).
 */
export function stateColor (task) {
  return STATE_COLORS[stateKey(task)] || STATE_COLORS.in_progress
}

/**
 * Color del texto del estatus en la vista de lista.
 */
export function listStateColor (task) {
  return LIST_STATE_COLORS[stateKey(task)] || LIST_STATE_COLORS.in_progress
}
